import { render, staticRenderFns } from "./ListingAgentProfile.vue?vue&type=template&id=c5180804&scoped=true&"
import script from "./ListingAgentProfile.vue?vue&type=script&lang=ts&"
export * from "./ListingAgentProfile.vue?vue&type=script&lang=ts&"
import style0 from "./ListingAgentProfile.vue?vue&type=style&index=0&id=c5180804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5180804",
  null
  
)

export default component.exports